export default __webpack_public_path__ + "fad62a864c0bbe9c23e7cc97c41bfb96.png";